<!-- <div class="body_wrap dashboard_body"> -->
<!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->
<div class="">
  <app-progress-indicator
    *ngIf="campaignState.isLoadingCampaignList$ | async"
    text="Please wait while we load"
  ></app-progress-indicator>
  <div class="mt-3">
    <div class="">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row">
            <div class="col-sm-12">
              <h4 class="mt-1 float-left" *ngIf="!isOpenInfo && isOpenCampaignInformation == false && !isAutomatedInfo">
                Campaigns
              </h4>
              <!-- <h4 class="mt-1 float-left" *ngIf="isOpenInfo">Campaign Information</h4> -->

              <div
                class="posButtonWrap text-right pl-3 float-right"
                *ngIf="!isOpenInfo && selectedCampaignType != 'automated'"
              >
                <button mat-flat-button color="primary" class="ml-2 addBtn" (click)="openCampaignSheet()">
                  <p class="mb-0">Create Campaign</p>
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-sm-12 mt-2">
              <div
                *ngIf="
                  appState.appCompanyAliasValue === 'valuetest'
                    ? canViewAgentMarketing === true
                    : userRole === 'agent' || userRole === 'loanOfficer' || userRole === 'companyManager'
                "
              >
                <div *ngIf="!isOpenInfo && isOpenCampaignInformation == false && !isAutomatedInfo">
                  <mat-radio-group color="primary" [(ngModel)]="selectedCampaignType">
                    <mat-radio-button value="self" class="mr-3">&nbsp;Manual Campaigns</mat-radio-button>
                    <mat-radio-button value="automated">&nbsp;Automated Campaigns</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div>
                  <ng-container *ngIf="selectedCampaignType === 'automated'">
                    <app-agent-marketing-campaigns
                      (isOpenCampaignInfo)="onBooleanChanged($event)"
                    ></app-agent-marketing-campaigns>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="wrap_body campaign_dashboard">
          <div class="mb-3 row" *ngIf="!isOpenInfo && selectedCampaignType != 'automated'">
            <div class="col-lg-12 mt-4">
              <div class="table_base">
                <div class="table-responsive table_wrap">
                  <table mat-table [dataSource]="tableDataSource" class="mat-elevation-z2 w-100">
                    <ng-container matColumnDef="campaignName">
                      <th mat-header-cell *matHeaderCellDef>Campaign Name</th>
                      <td mat-cell *matCellDef="let element">
                        <span class="truncated mt-0"> {{ element.campaignName }}</span>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="campaignType" *ngIf="appState.appCompanyAliasValue == 'valuetest'">
                      <th mat-header-cell *matHeaderCellDef>Type</th>
                      <td mat-cell *matCellDef="let element">
                        <span class="truncated mt-0">
                          {{
                            element.type == 'CAMP_VALUETEST_REPORT'
                              ? 'ValueTest Report'
                              : element.type == 'CAMP_COMPCHECK_REPORT'
                              ? 'CompCheck Report'
                              : element.type == 'CAMP_MY_HOME'
                              ? 'My Home'
                              : '--'
                          }}</span
                        >
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="candidateCount">
                      <th mat-header-cell *matHeaderCellDef class="align-center">Total Targets</th>
                      <td mat-cell *matCellDef="let element" class="align-center">
                        {{ element.candidateCount }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="emailOpenRate">
                      <th mat-header-cell *matHeaderCellDef class="align-center">Open Rate</th>
                      <td mat-cell *matCellDef="let element" class="align-center">
                        {{
                          element.status != 'idle'
                            ? element.totalSentCount
                              ? ((element.totalReadCount / element.totalSentCount) * 100).toFixed(0) + '%'
                              : 0 + '%'
                            : '-'
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="userOnboardRate" *ngIf="appState.appCompanyAliasValue != 'valuetest'">
                      <th mat-header-cell *matHeaderCellDef class="align-center">Lead Capture Rate</th>
                      <td mat-cell *matCellDef="let element" class="align-center">
                        {{
                          element.status != 'idle'
                            ? (element.candidateCount
                                ? ((element.userOnboardCount / element.candidateCount) * 100 | number: '1.0-0')
                                : 0) + '%'
                            : '-'
                        }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="createdDate">
                      <th mat-header-cell *matHeaderCellDef>Created On</th>
                      <td mat-cell *matCellDef="let element">{{ element.createdDate | simpleDate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="launchDate">
                      <th mat-header-cell *matHeaderCellDef>Launched On</th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.status != 'idle' ? (element.launchDate | simpleDate) : '-' }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="updatedDate">
                      <th mat-header-cell *matHeaderCellDef>Recent Activity</th>
                      <td mat-cell *matCellDef="let element">{{ element.updatedDate | simpleDate }}</td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                      <th mat-header-cell *matHeaderCellDef class="actionsWrap">Actions</th>
                      <td mat-cell *matCellDef="let element" class="actionsWrap">
                        <ng-container *ngIf="element.createdBy != 'system'">
                          <button
                            mat-icon-button
                            color="primary"
                            aria-label="Launch Campaign"
                            matTooltip="Launch Campaign"
                            matTooltipPosition="left"
                            *ngIf="element.status == 'idle'"
                            (click)="launchCampaign(element)"
                          >
                            <mat-icon>rocket_launch</mat-icon>
                          </button>
                          <button
                            mat-icon-button
                            aria-label="More Options"
                            matTooltip="More Options"
                            matTooltipPosition="left"
                            [matMenuTriggerFor]="menu"
                            *ngIf="element.status == 'idle'"
                            (click)="$event.stopPropagation()"
                          >
                            <mat-icon>more_vert</mat-icon>
                          </button>
                          <mat-menu #menu="matMenu" class="matSmall" xPosition="before">
                            <button mat-menu-item (click)="openCampaignSheet(element)">
                              <mat-icon>edit</mat-icon><span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="deleteCampaign(element._id)">
                              <mat-icon>delete</mat-icon><span>Delete</span>
                            </button>
                          </mat-menu>
                        </ng-container>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                    <tr
                      mat-row
                      (click)="row.status != 'idle' ? openInfo(row) : null"
                      *matRowDef="let row; columns: tableColumnList"
                    ></tr>
                  </table>
                </div>

                <mat-paginator
                  *ngIf="isValueTest"
                  [length]="totalRecordCount"
                  [pageSize]="pageSize"
                  [pageIndex]="pageIndex"
                  [pageSizeOptions]="[10, 20]"
                  (page)="pageChange($event)"
                  showFirstLastButtons
                >
                </mat-paginator>

                <div class="custom-paginator" *ngIf="!isValueTest">
                  <div *ngIf="campaignDataList.length != 0">
                    <button
                      mat-icon-button
                      color="primary"
                      class="nav-btn"
                      (click)="previousPage()"
                      [disabled]="pageIndex === 0"
                    >
                      <mat-icon>chevron_left</mat-icon>
                    </button>

                    <span class="page-label">Page {{ campPageIndex + 1 }}</span>

                    <button
                      mat-icon-button
                      color="primary"
                      class="nav-btn"
                      (click)="nextPage()"
                      [disabled]="disableNext"
                    >
                      <mat-icon>chevron_right</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <div
                class="flex_center w-100"
                *ngIf="!(campaignState.isLoadingCampaignList$ | async) && (!tableDataSource || !tableDataSource.data)"
              >
                <div class="notFound text-center noData">
                  <div>
                    <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                    <h4>No search result found</h4>
                  </div>
                </div>
              </div>
              <div class="flex_center w-100" *ngIf="campaignDataList.length == 0">
                <div class="notFound text-center noData">
                  <div>
                    <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                    <h4>No Campaigns Found</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <app-campaign-info
            *ngIf="isOpenInfo"
            (isOpenInfoEvent)="onBack($event)"
            [selectedInfo]="selectedInfo"
          ></app-campaign-info>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->

<ng-template #editCampaignDialog>
  <div class="addGroupWrap">
    <h2 matDialogTitle class="text-center mb-1">Rename Campaign</h2>
    <div mat-dialog-content>
      <form class="mt-2">
        <mat-form-field>
          <input
            matInput
            placeholder="Campaign name"
            type="text"
            name="campaignName"
            [(ngModel)]="campaignNewName"
            (keydown.enter)="(true)"
            autocomplete="off"
          />
        </mat-form-field>
      </form>
    </div>
    <mat-dialog-actions>
      <div class="w-100 text-right">
        <button mat-button (click)="matDialog.closeAll()">Cancel</button>
        <button
          class="ml-1"
          cdkFocusInitial
          mat-flat-button
          color="primary"
          (click)="renameCampaign(activeCampaignId, campaignNewName)"
        >
          Rename
          <!-- <mat-spinner [diameter]="30" *ngIf="addingNewGroupInProgress" class="spinner_size mr-3"></mat-spinner> -->
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</ng-template>
